import { useState } from 'react';
import { useQuery } from 'react-query';
import { fetchStyles } from '../../api/styles.api';
import { FilterImageCollapse } from '../atoms/Collapse';
import { FilterAccordion } from '../organisms/Sidebar/FilterAccordion';

export const FiltersStylesCollapse = ({ show, setShow }) => {
  const [openAccordion, setOpenAccordion] = useState(false);
  const { data } = useQuery('styles', () => fetchStyles(''));

  return (
    <FilterImageCollapse
      label={'Styles'}
      show={show}
      setShow={setShow}
      id={'styles'}
    >
      {data?.map((item, index) => {
        return (
          <FilterAccordion
            key={index}
            open={openAccordion}
            setOpen={setOpenAccordion}
            data={item}
            parentKey={'styles'}
          />
        );
      })}
    </FilterImageCollapse>
  );
};
